import {post} from "@/util/requestUtils"

export function saveVisitTracking(data, success) {
  return post("/visit-tracking/public-api/visit-log", data, success);
}
